import { defineStore } from 'pinia';
/**
 * Returns the default state for the reports store.
 */
function getDefaultState() {
    return {
        dateRange: {
            start: null,
            end: null,
            compareStart: null,
            compareEnd: null
        },
        resolution: 'hourly',
        isLoadingReport: false,
        selectedTimezone: null
    };
}
export const useReportsStore = defineStore('reports', {
    state: () => ({
        ...getDefaultState()
    }),
    actions: {
        /**
         * Resets the store state to its default values.
         */
        resetStateAction() {
            this.$reset();
        },
        /**
         * Sets the date range via action.
         * @param params - Parameters object containing date range values
         * @param params.start - The start date (ISO8601) or null
         * @param params.end - The end date (ISO8601) or null
         * @param params.compareStart - The comparison start date or null
         * @param params.compareEnd - The comparison end date or null
         */
        setDateRange({ start, end, compareStart, compareEnd }) {
            this.dateRange.start = start;
            this.dateRange.end = end;
            this.dateRange.compareStart = compareStart;
            this.dateRange.compareEnd = compareEnd;
        },
        /**
         * Sets the resolution via action.
         * @param params - Parameters object containing resolution value
         * @param params.resolution - The new resolution value
         */
        setResolution({ resolution }) {
            this.resolution = resolution;
        },
        /**
         * Sets the loading state for reports via action.
         * @param isLoadingReport - True if a report is loading
         */
        setIsLoadingReport(isLoadingReport) {
            this.isLoadingReport = isLoadingReport;
        },
        /**
         * Resets the store state via action.
         */
        resetState() {
            this.resetStateAction();
        },
        /**
         * Sets the selected timezone via action.
         * @param timezone - The selected timezone or null
         */
        setSelectedTimezoneAction(timezone) {
            this.selectedTimezone = timezone;
        }
    }
});
